import React from 'react'
import "../styles/Footer.css"

const Footer = () => {
    return (
        <div className='footer-cont'>
            <h3>Contact Developer</h3>
            <div className="contact-btn">
                <a href="https://www.linkedin.com/in/oxsuyash/" target="_blank" rel="noreferrer"><button>LinkedIn</button></a>
                <a href="https://github.com/OxSuyash" target="_blank" rel="noreferrer"><button>Github</button></a>

            </div>
        </div>
    )
}

export default Footer
